// 正式
module.exports = {
  title: '给缘',
  baseUrl: 'http://wap.yiguowl.top/', // 正式项目地址
  baseApi: '/' // 正式api请求地址
}



// WEBPACK FOOTER //
// ./src/config/env.production.js